var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWishlistIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0535 8.79521C13.6467 7.44775 16.4165 10.1052 17.3522 11.6024C18.4751 9.91809 21.7314 6.9986 25.7738 8.79521C29.8162 10.5918 28.9553 15.1582 28.0196 17.2168L17.3522 27.8842C15.4808 26.1999 10.9518 22.0452 7.80774 18.9011C3.87766 14.9711 5.56198 10.4795 10.0535 8.79521Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3863 9.24602C13.7089 6.5686 9.3773 6.55559 6.71146 9.22144C4.04561 11.8873 4.05862 16.2188 6.73605 18.8963L16.6472 28.8074C17.0583 29.2185 17.7248 29.2185 18.1359 28.8074L27.9956 18.9536C30.6553 16.2791 30.6468 11.9596 27.969 9.28175C25.2867 6.59953 20.9531 6.58651 18.2825 9.25712L17.3409 10.2006L16.3863 9.24602ZM26.5027 17.469L17.3916 26.5743L8.22479 17.4075C6.36758 15.5503 6.35857 12.5518 8.2002 10.7102C10.0418 8.86855 13.0403 8.87756 14.8975 10.7348L16.6016 12.4388C17.0197 12.8569 17.7001 12.8487 18.108 12.4206L19.7713 10.7459C21.6177 8.89948 24.6182 8.90849 26.4802 10.7705C28.3379 12.6282 28.3437 15.6177 26.5027 17.469Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistIcon2);
export default __webpack_public_path__ + "static/media/wishlist-icon2.e4cd3e1fd228ea178adb646e0b1615b9.svg";
export { ForwardRef as ReactComponent };